// Load Dependencies
import React, { Component } from "react";
import _ from "lodash";
import Moment from "moment";

// Load Store
import { HomeActionCreators } from "../../actions/actionCreators";
import { ActionCreator } from "../../../../actions/actions";
import { homeStoreSelectors } from "../../store/store";
import { connect } from "react-redux";

// Load Styles
import "./Notifications.component.scss";

const notifications = [
    {
        id: 1,
        date: "2020-03-18T10:42:19.147Z",
        title: "Nova Notícia!",
        subtitle: "New post!",
        read: false
    },
    {
        id: 2,
        service: "users",
        date: "2020-03-17T10:42:19.147Z",
        title: "Candidato marcado como Entrevista",
        subtitle:
            "Candidato Rui Monteiro (persona Software Developer - Backend) foi marcado como: Entrevista",
        read: false
    },
    {
        id: 3,
        date: "2020-03-16T10:42:19.147Z",
        title: "Nova Notícia!",
        subtitle: "New post!",
        read: false
    },
    {
        id: 4,
        service: "users",
        date: "2020-03-15T10:42:19.147Z",
        title: "Candidato marcado como Entrevista",
        subtitle:
            "Candidato Rui Monteiro (persona Software Developer - Backend) foi marcado como: Entrevista",
        read: true
    },
    {
        id: 5,
        date: "2020-03-14T10:42:19.147Z",
        title: "Nova Notícia!",
        subtitle: "New post!",
        read: true
    },
    {
        id: 6,
        date: "2020-03-13T10:42:19.147Z",
        title: "Candidato marcado como Entrevista",
        subtitle:
            "Candidato Rui Monteiro (persona Software Developer - Backend) foi marcado como: Entrevista",
        read: true
    },
    {
        id: 7,
        service: "users",
        date: "2020-03-12T10:42:19.147Z",
        title: "Nova Notícia!",
        subtitle: "New post!",
        read: true
    },
    {
        id: 8,
        date: "2020-03-11T10:42:19.147Z",
        title: "Candidato marcado como Entrevista",
        subtitle:
            "Candidato Rui Monteiro (persona Software Developer - Backend) foi marcado como: Entrevista",
        read: true
    },
    {
        id: 9,
        date: "2020-03-10T10:42:19.147Z",
        title: "Nova Notícia!",
        subtitle: "New post!",
        read: true
    },
    {
        id: 10,
        date: "2020-03-09T10:42:19.147Z",
        title: "Candidato marcado como Entrevista",
        subtitle:
            "Candidato Rui Monteiro (persona Software Developer - Backend) foi marcado como: Entrevista",
        read: true
    },
    {
        id: 11,
        service: "users",
        date: "2020-03-08T10:42:19.147Z",
        title: "Nova Notícia!",
        subtitle: "New post!",
        read: true
    },
    {
        id: 12,
        service: "users",
        date: "2020-03-07T10:42:19.147Z",
        title: "Candidato marcado como Entrevista",
        subtitle:
            "Candidato Rui Monteiro (persona Software Developer - Backend) foi marcado como: Entrevista",
        read: true
    },
    {
        id: 13,
        date: "2020-03-06T10:42:19.147Z",
        title: "Nova Notícia!",
        subtitle: "New post!",
        read: true
    },
    {
        id: 14,
        service: "users",
        date: "2020-03-05T10:42:19.147Z",
        title: "Candidato marcado como Entrevista",
        subtitle:
            "Candidato Rui Monteiro (persona Software Developer - Backend) foi marcado como: Entrevista",
        read: true
    },
    {
        id: 15,
        service: "users",
        date: "2020-03-04T10:42:19.147Z",
        title: "Nova Notícia!",
        subtitle: "New post!",
        read: true
    }
];

const serviceIcon = {
    users: "icon-user-light"
};

export interface NotificationsProps {
    notifications: any[];
}

class Notifcations extends Component<NotificationsProps> {
    markAsRead = () => {};

    deleteNotification = () => {};

    render() {
        return (
            <div className="notifications-container">
                {notifications.length > 0 &&
                    notifications.map(notification => {
                        return (
                            <div
                                className={`notification ${
                                    notification.read ? "read" : ""
                                }`}
                                key={notification.id}
                            >
                                <div className="icon">
                                    <i
                                        className={`${
                                            serviceIcon.hasOwnProperty(
                                                notification.service
                                            )
                                                ? serviceIcon[
                                                      notification.service
                                                  ]
                                                : "icon-newspaper-light"
                                        }`}
                                    ></i>
                                </div>
                                <div className="info">
                                    <p className="title">
                                        {notification.title}
                                    </p>
                                    <p className="subtitle">
                                        {notification.subtitle}
                                    </p>
                                    <p className="date">
                                        {Moment(notification.date)
                                            .format("DD MMM YYYY")
                                            .toUpperCase()}
                                    </p>
                                </div>
                                <div className="actions">
                                    {!notification.read && (
                                        <button onClick={this.markAsRead}>
                                            <i className="icon-eye-slash-light"></i>
                                        </button>
                                    )}
                                    <button onClick={this.deleteNotification}>
                                        <i className="icon-times-light"></i>
                                    </button>
                                </div>
                            </div>
                        );
                    })}
            </div>
        );
    }
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps, {})(Notifcations);
